const achievementCategoryStartParamPrefix = 'achievement-category-';

export const createAchievementCategoryStartParam = (templateCategoryId: string) =>
    `${achievementCategoryStartParamPrefix}${templateCategoryId}`;

export const getAchievementCategoryTemplateId = (startParam?: string) =>
    startParam?.startsWith(achievementCategoryStartParamPrefix) ? startParam.slice(achievementCategoryStartParamPrefix.length) : null;
